<template>
  <div class="tjing-sidebar-container">
    <Transition
      :name="side === 'left' ? 'slide-in-sidebar-left' : 'slide-in-sidebar'"
    >
      <aside
        class="tjing-sidebar"
        :class="{ 'tjing-sidebar--left': side === 'left' }"
        v-if="show"
      >
        <slot name="header" />
        <slot name="body" />
        <slot name="footer" />
      </aside>
    </Transition>
    <Transition name="fade-sidebar-overlay" v-if="showOverlay">
      <div
        class="tjing-sidebar-overlay"
        @touchmove.prevent="preventDefault"
        v-if="show"
        @click="preventClickOutside ? null : $emit('close')"
      ></div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'TjingSidebar',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Object,
      default: () => ({}),
    },
    showOverlay: {
      type: Boolean,
      default: true,
    },
    preventClickOutside: {
      type: Boolean,
      default: false,
    },
    side: {
      type: String,
      default: 'right',
    },
  },
  data() {
    return {}
  },
  computed: {
    onTjingMobile() {
      return this.$store.getters.onTjingMobile
    },
  },
  methods: {
    preventDefault(e) {
      e.preventDefault()
    },
  },
  watch: {
    show: function (newVal) {
      if (newVal) {
        if (this.showOverlay) {
          document.body.style.marginRight =
            window.innerWidth - document.documentElement.clientWidth + 'px'
          document.body.style.transition = 'none'

          document.body.style.overflow = 'hidden'
        }
      } else {
        setTimeout(() => {
          document.body.style.overflow = 'visible'
          document.body.style.marginRight = '0px'
        }, 100)
      }
    },
  },
  mounted() {
    const r = document.querySelectorAll('.tjing-sidebar-container')

    this.$parent.$el.style.setProperty(
      '--mobile-width',
      this.width.mobile ?? 'calc(100% - 35px)'
    )
    this.$parent.$el.style.setProperty(
      '--tablet-width',
      this.width.tablet ?? '400px'
    )
    this.$parent.$el.style.setProperty(
      '--laptop-width',
      this.width.laptop ?? '400px'
    )
    this.$parent.$el.style.setProperty(
      '--desktop-width',
      this.width.desktop ?? '400px'
    )
  },
  beforeMount() {},
  beforeCreate() {},
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';

.fade-sidebar-overlay-enter-active,
.fade-sidebar-overlay-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-sidebar-overlay-enter,
.fade-sidebar-overlay-leave-to {
  opacity: 0;
}

.tjing-sidebar-overlay {
  z-index: 99;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(125, 130, 150, 0.7);
}
.tjing-sidebar {
  z-index: 1000;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: var(--mobile-width);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 30px;
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  background: white;

  &--left {
    right: auto;
    left: 0;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    border-bottom-right-radius: 20px;
    border-top-right-radius: 20px;
  }
}

.slide-in-sidebar-enter-active,
.slide-in-sidebar-leave-active,
.slide-in-sidebar-left-enter-active,
.slide-in-sidebar-left-leave-active {
  transition: all 0.2s ease-in-out;
}

.slide-in-sidebar-enter,
.slide-in-sidebar-leave-to {
  right: -100%;
}

.slide-in-sidebar-left-enter,
.slide-in-sidebar-left-leave-to {
  left: -100%;
}

@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
  .tjing-sidebar {
    width: var(--tablet-width);
  }
  .slide-in-sidebar-enter,
  .slide-in-sidebar-leave-to {
    right: calc(var(--tablet-width) * -1);
  }
  .slide-in-sidebar-left-enter,
  .slide-in-sidebar-left-leave-to {
    left: calc(var(--tablet-width) * -1);
  }
}

@media (min-width: 1200px) {
  .tjing-sidebar {
    width: var(--laptop-width);
  }
  .slide-in-sidebar-enter,
  .slide-in-sidebar-leave-to {
    right: calc(var(--laptop-width) * -1);
  }
  .slide-in-sidebar-left-enter,
  .slide-in-sidebar-left-leave-to {
    left: calc(var(--laptop-width) * -1);
  }
}
@media (min-width: 1400px) {
  .tjing-sidebar {
    width: var(--desktop-width);
  }
  .slide-in-sidebar-enter,
  .slide-in-sidebar-leave-to {
    right: calc(var(--desktop-width) * -1);
  }
  .slide-in-sidebar-left-enter,
  .slide-in-sidebar-left-leave-to {
    left: calc(var(--desktop-width) * -1);
  }
}
</style>
